var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionMediaThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 171,
    viewBox: "0 0 193 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 171,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2842,
    y: 27.2875,
    width: 137.054,
    height: 117.425,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.391 25H46.2318C40.8678 25.0058 35.7252 27.15 31.9322 30.962C28.1393 34.774 26.0059 39.9425 26 45.3333V126.667C26.0059 132.058 28.1393 137.226 31.9322 141.039C35.7252 144.85 40.8678 146.994 46.2318 147H147.391C152.755 146.994 157.897 144.85 161.691 141.039C165.483 137.226 167.616 132.058 167.622 126.667V45.3333C167.616 39.9425 165.483 34.774 161.691 30.962C157.897 27.15 152.755 25.0058 147.391 25ZM122.101 45.3333C125.102 45.3333 128.036 46.2277 130.531 47.9035C133.026 49.5791 134.971 51.9609 136.12 54.7474C137.268 57.534 137.569 60.6002 136.983 63.5585C136.398 66.5167 134.952 69.234 132.83 71.3667C130.708 73.4994 128.005 74.9519 125.061 75.5403C122.118 76.1287 119.067 75.8267 116.294 74.6726C113.521 73.5183 111.152 71.5636 109.484 69.0557C107.817 66.548 106.927 63.5995 106.927 60.5833C106.931 56.5401 108.531 52.6636 111.376 49.8046C114.221 46.9456 118.078 45.3375 122.101 45.3333ZM46.2318 136.833C43.5489 136.833 40.9758 135.762 39.0787 133.856C37.1817 131.95 36.1159 129.363 36.1159 126.667V105.18L66.0968 78.3972C68.9895 75.8189 72.7514 74.446 76.6162 74.5581C80.481 74.6703 84.1579 76.2591 86.8976 79.0009L107.43 99.5916L70.374 136.833H46.2318ZM157.506 126.667C157.506 129.363 156.441 131.95 154.544 133.856C152.647 135.762 150.074 136.833 147.391 136.833H84.6816L123.065 98.2572C125.783 95.9345 129.231 94.6549 132.799 94.6456C136.366 94.6363 139.821 95.8979 142.551 98.2064L157.506 110.73V126.667Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionMediaThumbnail);
export default __webpack_public_path__ + "static/media/icon-section-media-thumbnail.3387290d4e82aaf8558825cad91c6b69.svg";
export { ForwardRef as ReactComponent };